import { inViewMargin } from '@helpers/animate';
import { useInView } from '@hooks/useInView';
import SvgClose from '@img/icons/quote-close.svg';
import SvgOpen from '@img/icons/quote-open.svg';
import * as React from 'react';
import S from './BlockQuoteBlock.styles';
const BlockQuoteBlock = ({ data }) => {
    const [refContainer, inView] = useInView({ rootMargin: inViewMargin });
    return (React.createElement(S.Container, { ref: refContainer, "data-color": data.color ?? 'grey', initial: "hidden", animate: inView ? 'visible' : 'hidden', variants: {
            hidden: {
                opacity: 0,
                y: 20,
            },
            visible: {
                opacity: 1,
                y: 0,
            },
        } },
        React.createElement(S.QuoteOpen, { as: SvgOpen }),
        React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: data.content } }),
        React.createElement(S.QuoteClose, { as: SvgClose })));
};
export default BlockQuoteBlock;
